
import React, {Component} from 'react';
import {Modal,FormControl,Button,ButtonToolbar,Nav,NavItem} from 'react-bootstrap'
import Select from 'react-select'
import FontAwesome from 'react-fontawesome'
import {Box} from 'reactjs-admin-lte'
import AutopartStore from '../../stores/AutopartStore'
import SWTStockPartItemEditModal from './SWTStockPartItemEditModal'
import SWTExPartItemList from './SWTExPartItemList'

class SWTPartItemListModal extends Component {

  constructor(...args){
    super(...args)
    this.state = {refreshOption:false,loading:false,activeTab:"1",showEdit:false,query:'',catOptions:[],tableData:[]}

    //this.openPopup() 
  }

  onShow(){
    this.openPopup();
  }

  openPopup(){
    this.setState({loading:true})
    let that = this
    AutopartStore.loadStockPartCategory(function(result){
      let options = result.data.map((item,index)=>{
        return {label:item.name,value:item.cat_id}
      })
      that.setState({loading:false,catOptions:options})

      that.loadStockPartItemList('-1')
    })

    
    
  }

  loadStockPartItemList(categoryId,query){
    let that = this
    AutopartStore.loadStockPartItemList(categoryId,query,function(result){
      that.setState({tableData:result.data,loading:false})
    })
  }

  onRefreshOptions(){
    this.openPopup()
  }

  onHide(){

  }

  onSelectChange(value){
    let {catSelect} = this.state
    if(value!==null)
      this.loadStockPartItemList(value.value);
    else
      this.loadStockPartItemList(-1);
    this.setState({catSelect:value,loading:true})
  }

  onSelectOpen(){
    let {refreshOption} = this.state
    if(refreshOption){
      this.openPopup()
      this.setState({refreshOption:false})
    }
  }

  onTextChange(e){
    let {catSelect} = this.state
    let query = e.target.value

    if(typeof query!=='undefined' && query.length>2){
      if(typeof catSelect!=='undefined' &&catSelect!==null){
        this.loadStockPartItemList(catSelect.value,query);
      }else{
        this.loadStockPartItemList(-1,query);
      }
      this.setState({loading:true})
    }
    this.setState({query:query})
    
  }

  onNewClick(){
    //this.refs.wageitemedit.loadItemcode(null)
    //this.setState({showEdit:true})
    if (process.env.NODE_ENV !== "development") {
      window.request_newstockpart();
      this.setState({refreshOption:true})
    }
  }

  onEditClick(item){
    //this.refs.wageitemedit.loadItemcode(item)
    //this.setState({showEdit:true})
    if (process.env.NODE_ENV !== "development") {
      window.request_editstockpart(item.itemnum);
    }
    

  }

  onRowClick(item){
    
    this.props.onSelect(item)
    
    this.props.onHide()
  }

  onExPartRowClick(item){
    this.props.onSelect(item)
    
    this.props.onHide()
  }

  onActiveTab(activeTab){
    this.setState({activeTab:activeTab})
  }

  onClearClick(){
    this.setState({query:'',catSelect:null})
    this.loadStockPartItemList('-1')
  }

  onAfterSubmit(){

  }

  renderSearch(){
    let {query,catSelect,catOptions} = this.state
    return (
      <div className='row form-group'>
        <div className='col-md-3'>
          <Select value={catSelect} placeholder={'เลือกหมวดหมู่'} options={catOptions} 
          onOpen={this.onSelectOpen.bind(this)}
          onChange={this.onSelectChange.bind(this)}/>
        </div> 
        <div className='col-md-8' style={{display:'inline-flex'}}>
          <FormControl value={query} onChange={this.onTextChange.bind(this)}/>
          <ButtonToolbar style={{width:'440px',marginLeft:'10px'}}>
            <Button onClick={this.onClearClick.bind(this)}><FontAwesome name="eraser"/>&nbsp;ลบการค้นหา</Button>
            <Button bsStyle={'primary'} onClick={this.onNewClick.bind(this)}><FontAwesome name="plus"/>&nbsp;เพิ่มรายการค่าอะไหล่</Button>
          </ButtonToolbar>
        </div> 

      </div>
    )
  }

  

  renderRowData(){
    let {tableData} = this.state
    return tableData.map((item,index)=>(
      <tr key={index}>
        <td  onClick={this.onRowClick.bind(this,item)}>{item.itemnum}</td>
        <td  onClick={this.onRowClick.bind(this,item)}>{item.cat_name}</td>
        <td  onClick={this.onRowClick.bind(this,item)}>{item.productcode}</td>
        <td  onClick={this.onRowClick.bind(this,item)}>{item.description}</td>
        <td  onClick={this.onRowClick.bind(this,item)} className='text-center'>{item.quantity}</td>
        <td  onClick={this.onRowClick.bind(this,item)}>{item.unit}</td>
        <td  onClick={this.onRowClick.bind(this,item)} className='text-right'>{item.price_per_unit}</td>
        <td className='text-center'><Button onClick={this.onEditClick.bind(this,item)}>แก้ไข</Button></td>
      </tr>
    )) 
  }

  renderSearchResult(){
    return (
      <table className='table table-responsive table-hover table-bordered-solid'>
        <thead>
          <tr>
            <th>#ID</th>
            <th>หมวดหมู่</th>
            <th>รหัสสินค้า</th>
            <th>รายการ</th>
            <th>จำนวน</th>
            <th>หน่วยนับ</th>
            <th>ราคาต่อหน่วย</th>
            <th>แก้ไข</th>
          </tr>
        </thead>
        <tbody>
          {this.renderRowData()}
        </tbody>
        
      </table>
    )
  }

 
  renderTab1(){
    let {loading} = this.state
    return (
      <div className='box' >
        <div className='box-body'>
          {this.renderSearch()}
          {this.renderSearchResult()}
        </div>
        <div className="overlay" style={{display:(loading?'block':'none')}}>
          <i className="fa fa-refresh fa-spin"></i>
        </div>
      </div>
    )
  }

  renderTab2(){
    let {loading} = this.state
    return (
      <Box loading={loading}>
        <Box.Body>
        {this.renderExPartSearch()}
        {this.renderExPartSearchResult()}
        </Box.Body>
      </Box>      
    )
  }


  
  renderTab(){
    let {activeTab} = this.state
    return (
      <div>
        <Nav bsStyle="tabs" activeKey={activeTab} onSelect={this.onActiveTab.bind(this)}>
          <NavItem eventKey="1" >รายการอะไหล่ในสต๊อก</NavItem>
          <NavItem eventKey="2" >รายชื่ออะไหล่นอกสต๊อก</NavItem>
        </Nav>
        <div style={{display:(activeTab==="1")?'block':'none'}}>
          {this.renderTab1()}
        </div>
        
      </div>
    )
  }

  render(){
    let {show} = this.props
    let {loading,showEdit,catOptions} = this.state
    return (
      <Modal show={show} onShow={this.onShow.bind(this)} enforceFocus={false} onHide={this.props.onHide} dialogClassName="midwidth-dialog">
        <Modal.Header closeButton>
          <Modal.Title>{'ค้นหารายการอะไหล่ (กดบนแถวเพื่อเลือกรายการ)'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.renderTab1()}
          <SWTStockPartItemEditModal  ref={'wageitemedit'} show={showEdit} 
          catOptions={catOptions} 
          onRefreshOptions={this.onRefreshOptions.bind(this)}
          onAfterSubmit={this.onAfterSubmit.bind(this)}
          onHide={()=>{this.setState({showEdit:false})}}/>
        </Modal.Body>
        <Modal.Footer>
        </Modal.Footer>
      </Modal>
    )
  }
}


export default SWTPartItemListModal;





// WEBPACK FOOTER //
// ./src/view/workdoc/SWTPartItemListModal.js